var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95987 3.03417C6.95987 3.42057 7.27268 3.73417 7.65812 3.73417H16.5026C16.8883 3.73417 17.2009 3.42077 17.2009 3.03417C17.2009 2.64757 16.8883 2.33417 16.5026 2.33417H7.65812C7.27249 2.33417 6.95987 2.64757 6.95987 3.03417ZM3.70136 0.4675V5.13417H2.30486V1.12083H1.37386V0.1875H3.70136V0.4675ZM0.762187 14.334L3.17348 11.2942H3.16138C3.29653 11.0588 3.24374 10.7601 3.03614 10.5857C2.82854 10.4112 2.52598 10.4112 2.31838 10.5857C2.11078 10.7601 2.05799 11.0588 2.19314 11.2942H0.724016C0.689654 10.6059 1.0364 9.95455 1.62594 9.60006C2.21549 9.24557 2.9519 9.24557 3.54144 9.60006C4.13099 9.95455 4.47773 10.6059 4.44337 11.2942H4.44244C4.39775 11.6722 4.29348 11.9792 4.13241 12.2163C3.96949 12.4534 3.58312 12.8622 2.97425 13.4408H4.44616V14.3742H0.722154L0.762187 14.334ZM6.95987 11.4342C6.95987 11.0476 7.27249 10.7342 7.65812 10.7342H16.5026C16.8883 10.7342 17.2009 11.0476 17.2009 11.4342C17.2009 11.8208 16.8883 12.1342 16.5026 12.1342H7.65812C7.27249 12.1342 6.95987 11.8208 6.95987 11.4342Z",
    fill: "#31393C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberedList);
export default ForwardRef;